import {
    Fab,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Tooltip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { showConfirmDialog } from '../ui/redux/uiSlices';
import { CreateUserGroupDialog } from './dialogs/CreateUserGroupDialog';
import { getUserGroups } from './redux/userGroupSelectors';
import { removeUserGroup, UserGroup } from './redux/userGroupSlices';
const mapStateToProps = (state: RootState) => ({
    userGroups: Object.values(getUserGroups(state)).sort((a, b) => a.name.localeCompare(b.name))
});

type Props = ReturnType<typeof mapStateToProps> & {
    selectedUserGroup: UserGroup | null;
    setSelectedUserGroup: (userGroup: UserGroup) => void;
};

const UserGroupList = ({ userGroups, selectedUserGroup, setSelectedUserGroup }: Props) => {
    const [showCreateUserGroupDialog, setShowCreateUserGroupDialog] = useState(false);
    const [hoveredUserGroupId, setHoveredUserGroupId] = useState(-1);

    const dispatch = useDispatch();

    const handleAddClick = () => {
        setShowCreateUserGroupDialog(true);
    };

    const handleCloseCreateUserGroupDialog = () => {
        setShowCreateUserGroupDialog(false);
    };

    const handleUserGroupSelected = (ug: UserGroup) => {
        setSelectedUserGroup(ug);
    };

    const handleOnMouseOver = (userGroupId: number) => {
        setHoveredUserGroupId(userGroupId);
    };

    const handleOnMouseLeave = () => {
        setHoveredUserGroupId(-1);
    };

    const handleRemoveGroup = (ug: UserGroup) => {
        dispatch(
            showConfirmDialog({
                dialogTitle: `Remove ${ug.name}`,
                dialogMessage: `Do you want to remove group ${ug.name}?`,
                primaryActionName: 'Remove',
                okAction: removeUserGroup.request(ug.userGroupId)
            })
        );
    };

    return (
        <>
            <Grid container direction="column">
                <Grid item>
                    <Grid container>
                        <Grid item>
                            <Tooltip title="Create new user group">
                                <span>
                                    <Fab size="small" color="primary" onClick={handleAddClick}>
                                        <AddIcon />
                                    </Fab>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <List dense onMouseLeave={() => handleOnMouseLeave()}>
                        {userGroups.map(ug => (
                            <ListItem
                                button
                                key={ug.userGroupId}
                                selected={selectedUserGroup?.userGroupId === ug.userGroupId}
                                onClick={() => handleUserGroupSelected(ug)}
                                onMouseOver={() => handleOnMouseOver(ug.userGroupId)}
                            >
                                <ListItemText primary={ug.name} />
                                {hoveredUserGroupId === ug.userGroupId && (
                                    <ListItemSecondaryAction>
                                        <Tooltip title={`Remove group`}>
                                            <IconButton
                                                onClick={() => handleRemoveGroup(ug)}
                                                color="secondary"
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </ListItemSecondaryAction>
                                )}
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </Grid>
            {showCreateUserGroupDialog && (
                <CreateUserGroupDialog closeDialog={handleCloseCreateUserGroupDialog} />
            )}
        </>
    );
};

export default connect(mapStateToProps)(UserGroupList);
